// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3qiOI","type":"styles_type__1lg7N","choices":"styles_choices__1yThj"};